module.exports = __webpack_public_path__ + "img/child-of-love-thumb.52e72d17.jpg";